import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { SmmService } from 'app/_services/smm.service';
import { ServiceConfig } from 'app/_services/service-config';
import { ProjectsService } from 'app/_services/projects.service';
import { DashboardFilterService } from '../dashboard-filter/dashboard-filter.service';
declare var global: any;
var Color = global.Color;
const moment = require('moment');
@Component({
	selector: 'app-dashboard3',
	templateUrl: './dashboard3.component.html',
	styleUrls: ['./dashboard3.component.scss']
})

export class Dashboard3Component implements OnInit {
	@ViewChild('mainBarChart1') mainBarChart1: BaseChartDirective;
	@ViewChild('mainBarChart2') mainBarChart2: BaseChartDirective;
	@ViewChild('mainBarChart3') mainBarChart3: BaseChartDirective;

	projectFilter = true;
	brandFilter = true;
	isShowChart3 = false;
	isShowChart2 = false;
	isShowChart1 = false;
	notSpam = true;
	barChartType = 'bar';
	barChartColours: Array<any> = [
		{ // Series B2f7347
			backgroundColor: Color('#2f7347').alpha(0.8).rgbString(),
			borderWidth: 1
		},
		{ // Series B
			backgroundColor: Color('#F8061E').alpha(0.8).rgbString(),
			borderWidth: 1
		},
		{ // Series B
			backgroundColor: Color('#4e99af').alpha(0.8).rgbString(),
			borderWidth: 1
		},
		{ // Series B
			backgroundColor: Color('#8a6641').alpha(0.8).rgbString(),
			borderWidth: 1
		},
		{ // Series B
			backgroundColor: Color('#0f6d7c').alpha(0.8).rgbString(),
			borderWidth: 1
		},
		{ // Series B
			backgroundColor: Color('#f84e5d').alpha(0.8).rgbString(),
			borderWidth: 1
		},
		{ // Series B
			backgroundColor: Color('#0c3f51').alpha(0.8).rgbString(),
			borderWidth: 1
		},
		{ // Series B
			backgroundColor: Color('#4875b4').alpha(0.8).rgbString(),
			borderWidth: 1
		},
		{ // Series B
			backgroundColor: Color('#b4b2ad').alpha(0.8).rgbString(),
			borderWidth: 1
		}
	];
	barChart1Options = null;
	barChart1Labels: string[] = [];
	barChart1Data: any[] = [
		// { data: [3, 4, 7], label: 'Tích Cực' },
		// { data: [3, 5, 4], label: 'Tiêu Cực' },
		// { data: [3, 6, 4], label: 'Trung Tính' }
	];
	barChart2Options = null;
	barChart2Labels: string[] = ['Facebook', 'Youtube', 'News', 'Forum'];
	barChart2Data: any[] = [
		// { data: [], label: 'Vinaphone' },
		// { data: [], label: 'vnpt' },
		// { data: [], label: 'VNPT pay' }
	];
	barChart3Options = null;
	barChart3Labels: string[] = [];
	barChart3Data: any[] = [
		// { data: [], label: 'Vinaphone' },
		// { data: [], label: 'vnpt' },
		// { data: [], label: 'VNPT pay' }
	];

	projectSelected = [];
	projects = [];

	brands = [];
	brandSelectedFilter = [];

	daterange: any = {
		start: moment().subtract(1, "days").startOf('day'),
		end: moment().subtract(1, "days").endOf('day')
	  };


	options: any = {
		locale: {
			format: 'DD/MM/YYYY', //  HH:mm:ss
			applyLabel: 'Áp dụng',
			cancelLabel: 'Hủy',
			fromLabel: 'Từ',
			toLabel: 'Tới',
			customRangeLabel: 'Tùy chọn',
			daysOfWeek: ['CN', 'Hai', 'Ba', 'Tư', 'Năm', 'Sáu', 'Bảy'],
			monthNames: ['Tháng 1 -', 'Tháng 2 -', 'Tháng 3 -', 'Tháng 4 -', 'Tháng 5 -', 'Tháng 6 -',
				'Tháng 7 -', 'Tháng 8 -', 'Tháng 9 -', 'Tháng 10 -', 'Tháng 11 -', 'Tháng 12 -']
		},
		timePicker: false,
		datePicker: false,
		alwaysShowCalendars: false,
		ranges: {
			// 'Toàn thời gian': [moment('20170429').startOf('day'), moment().endOf('day')],
			// '24 giờ': [moment().subtract(1, 'day'), moment()],
			'Hôm nay': [moment().startOf('day'), moment().endOf('day')],
			// 'Hôm qua': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
			'Tuần này': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
			'Tuần trước': [moment().subtract(1, 'week').startOf('isoWeek'), moment().subtract(1, 'week').endOf('isoWeek')],
			'Tháng này': [moment().startOf('month'), moment().endOf('month')],
			'Tháng trước': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
		},
		opens: 'right',
		maxDate: moment().endOf('day').toDate(),
		timePicker24Hour: false,
		timePickerSeconds: false,
		startDate: this.daterange.start,
		endDate: this.daterange.end
	};
	brandDropDownSettings = {
		singleSelection: false,
		text: 'Chọn thương hiệu',
		selectAllText: 'Chọn tất cả',
		unSelectAllText: 'Bỏ chọn tất cả',
		enableSearchFilter: false,
		badgeShowLimit: 2,
	};
	projectDropDownSettings = {
		singleSelection: false,
		text: 'Chọn chủ đề',
		selectAllText: 'Chọn tất cả',
		unSelectAllText: 'Bỏ chọn tất cả',
		enableSearchFilter: false,
		badgeShowLimit: 2,
	};



	constructor(private postService: SmmService,
		private projectsService: ProjectsService,
		private dashboardFilterService: DashboardFilterService
	) {
		this.barChart1Options = this.getOptionsChart('Thảo luận');
		this.barChart2Options = this.getOptionsChart('Tương tác');
		this.barChart3Options = this.getOptionsChart('Thảo luận');
		this.getProject();
		this.getBrands();  
	}

	ngOnInit() {

	}

	selectedDate(value: any, datepicker?: any) {
		datepicker.start = value.start.startOf('day');
		datepicker.end = value.end.endOf('day');
		this.options.startDate = this.daterange.start;
		this.options.endDate = this.daterange.end;
		this.getDataFromServer();
	  }

	getOptionsChart(yLabel) {
		const barChartOptions = {
			// scaleShowVerticalLines: false,
			// responsive: false
			maintainAspectRatio: false,
			plugins: {
				labels: false
			},
			tooltips: {
				mode: 'index',
				intersect: false,
				position: 'nearest',
				// convert to % . author : vdthuan
				callbacks: {
					label: function (tooltipItem, data) {
						var index = tooltipItem.index;
						var currentValue = data.datasets[tooltipItem.datasetIndex].data[index];
						var total = 0;
						data.datasets.forEach(function (el) {
							total = total + el.data[index];
						});
						var percentage = parseFloat((currentValue / total * 100).toFixed(1)) || 0;
						return currentValue + ' (' + percentage + '%)';
					}
					// ,
					// title: function (tooltipItem, data) {
					//     return data.datasets[tooltipItem[0].datasetIndex].label;
					// }
				}
			},
			scales: {
				xAxes: [{
					display: true,
					stacked: true,
					barPercentage: 0.6,
					ticks: {
						beginAtZero: true,
						fontColor: '#0099ff'

					},
					gridLines: {
						color: '#5f5e5e'  // grid line color (can be removed or changed)
					},
					distribution: 'series',
					// type: 'time',
					time: {
						displayFormats: {
							quarter: 'MMM DD'
						},
						// unit: 'hour'
					}
				}],
				responsive: true,
				yAxes: [{
					stacked: true,
					display: true,
					ticks: {
						beginAtZero: true,
						fontColor: '#0099ff'
					},
					gridLines: {
						color: '#5f5e5e'  // grid line color (can be removed or changed)
					},
					scaleLabel: {
						display: true,
						labelString: yLabel,
						fontColor: '#0099ff'
					}
				}]
			},
			legend: {
				usePointStyle: true,
				display: true,
				labels: {
					fontSize: 12,
					fontColor: '#0099ff'
				}
				// onClick: this.mainBarChartClicked,
			},
		};
		return barChartOptions;
	}
	getDataFromServer() {
		this.dashboardFilterService.openLoader(true);
		var app = this;
		setTimeout(
			function () { app.dashboardFilterService.openLoader(false); }, 1900
		  );
		const filter = {
			projectsSelected : this.projectSelected,
			brandsSelected : this.brandSelectedFilter,
			gte: this.daterange.start.valueOf(),
			lte: this.daterange.end.valueOf(),
			notSpam: this.notSpam,
			index  :'full',
		}
		let options1 = {
			filter: filter,
			mode: 'chart1'
		}
		this.postService.getTrademarkData(options1).subscribe(res => {
			if (res.success) {
				this.mappingDataChart1(res.data.aggregations)
			} else {
				this.isShowChart1 = false;
			}
		});
		let options2 = {
			filter: filter,
			mode: 'chart2'
		}
		this.postService.getTrademarkData(options2).subscribe(res => {
			if (res.success) {
				this.mappingDataChart2(res.data.aggregations)
				// this.isShowChart2 = true;
			} else {
				this.isShowChart2 = false;
			}
		});
		let options3 = {
			filter: filter,
			mode: 'chart3',
			// projects: projects,
			// projectsIds :projectsIds
		}
		this.postService.getTrademarkData(options3).subscribe(res => {
			if (res.success) {
				// this.isShowChart3 = true;
				this.mappingDataChart3(res.discussProjects, res.data.aggregations)
			} else {
				this.isShowChart3 = false;
			}
		});
	}
	getProject() {
		this.projectsService.index().subscribe(response => {
			if (response.success) {
				response.data.projects.forEach(element => {
					let projectItem = {
						id: element._id,
						itemName: element.name,
						value: element.name
					};
					this.projects.push(projectItem);
				});
			}
		});
	}

	getBrands() {
		this.projectsService.getBrandsActiveV2().subscribe(res => {
			if (res.success) {
				res.data.forEach(element => {
					let obj = {
						id: element._id,
						itemName: element.name,
						value: element.name
					};
					this.brands.push(obj);
				});
				if(this.brands.length > 0) {
					this.brandSelectedFilter.push(this.brands[0]);
					this.getDataFromServer();
				}
			}
		});
	}
	async mappingDataChart3(discussProjects, data) {
		this.barChart3Labels = [];
		this.barChart3Data = [];
		this.isShowChart3 = false;

		this.brandSelectedFilter.forEach(item => {
			const dataItem = {
				data: [], label: item.itemName, mappingData: {}
			}
			this.barChart3Data.push(dataItem);
		});

		this.projectSelected.forEach(item => {
			const dataItem = {
				data: [], label: item.itemName, mappingData: {}
			}
			this.barChart3Data.push(dataItem);
		});

		// let await1s = await this.resolveAfter1Seconds()

		discussProjects.forEach(discussProjectItem => {
			this.barChart3Labels.push(discussProjectItem.name)
			this.barChart3Data.forEach((item, _index) => {
				this.barChart3Data[_index].mappingData[discussProjectItem.name] = 0;
			});
		});
		for (var projectName in data) {
			this.barChart3Data.forEach((element, _idx) => {
				if (element.label == projectName && data[projectName].statistic_project.statistic.statistic.statistic) {
					data[projectName].statistic_project.statistic.statistic.statistic.buckets.forEach(item => {
						item.key
						this.barChart3Data[_idx].mappingData[item.key] = item.doc_count;
					});
				}
			});
		}

		this.barChart3Data.forEach((element, _idx) => {
			for (var keyDiscussProject in element.mappingData) {
				this.barChart3Data[_idx].data.push(element.mappingData[keyDiscussProject]);
			}
		});
		let await1s = await this.resolveAfter1Seconds()
		this.isShowChart3 = true;
		//  let await1s = await this.resolveAfter1Seconds()
		const ci = this.mainBarChart3 ? this.mainBarChart3.chart : null;
		if (ci) {
			ci.config.data.labels = this.barChart3Labels;
			ci.update();
		}

	}
	resolveAfter1Seconds() {
		return new Promise(resolve => {
			setTimeout(() => {
				resolve('resolved');
			}, 1000);
		});
	}


	async mappingDataChart2(data) {
		this.barChart2Data = [];
		this.barChart2Labels = [];
		this.isShowChart2 = false;

		this.brandSelectedFilter.forEach(item => {
			const dataItem = {
				data: [], label: item.value
			}
			this.barChart2Data.push(dataItem);
		});

		this.projectSelected.forEach(item => {
			const dataItem = {
				data: [], label: item.value
			}
			this.barChart2Data.push(dataItem);
		});


		for (var brandName in data) {
			this.barChart2Data.forEach((item, index) => {
				if (item.label == brandName) {
					let totalFacebook = 0;
					let totalNews = 0;
					let totalForum = 0;
					let totalYoutube = 0;
					let totalTiktok = 0;
					let totalInstagram = 0;
					let totalLinkedin = 0;
					data[brandName].statistic.docTypesCount.filter.buckets.forEach(item => {
						if (item.key == 'comment' || item.key == 'page_post' || item.key == 'user_post' || item.key == 'group_post') {
							totalFacebook += item.doc_count;
						}
						if (item.key == 'news_article') {
							totalNews += item.doc_count;
						}
						if (item.key == 'news_blog') {
							totalForum += item.doc_count;
						}
						if (item.key == 'youtube' || item.key == 'youtube_comment') {
							totalYoutube += item.doc_count;
						}
						if (item.key == 'tiktok' || item.key == 'tiktok_comment') {
							totalTiktok += item.doc_count;
						}
						if (item.key == 'instagram' || item.key == 'instagram_comment') {
							totalInstagram += item.doc_count;
						}
						if (item.key == 'linkedin' || item.key == 'linkedin_comment') {
							totalLinkedin += item.doc_count;
						}
					});
					this.barChart2Data[index].data.push(totalFacebook, totalYoutube,totalTiktok,totalInstagram,totalLinkedin, totalNews, totalForum);
				}
			})
		}



		this.barChart2Labels = ['Facebook', 'Youtube', 'Tiktok','Instagram','Linkedin', 'News', 'Forum'];
		let await1s = await this.resolveAfter1Seconds()
		this.isShowChart2 = true;

		// const ci = this.mainBarChart2 ? this.mainBarChart2.chart : null;
		// if (ci) {
		//     ci.config.data.labels = this.barChart2Labels;
		//     ci.update();
		// }
	}

	mappingDataChart1(data) {
		this.barChart1Labels = [];
		this.barChart1Data = [];
		this.isShowChart1 = false;;

		let pos = { data: [], label: 'Tích Cực' };
		let neg = { data: [], label: 'Tiêu Cực' };
		let neu = { data: [], label: 'Trung Tính' };
		for (var projectName in data) {
			this.barChart1Labels.push(projectName);
			data[projectName].statistic.seg.buckets.forEach(item => {
				if (item.key == 'pos') {
					pos.data.push(item.doc_count);
				}
				if (item.key == 'neu') {
					neu.data.push(item.doc_count);
				}
				if (item.key == 'neg') {
					neg.data.push(item.doc_count);
				}
			});
		}
		this.barChart1Data.push(pos, neg, neu);
		this.isShowChart1 = true;


		const ci = this.mainBarChart1 ? this.mainBarChart1.chart : null;
		if (ci) {
			ci.config.data.labels = this.barChart1Labels;
			ci.update();
		}
	}


}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard3/dashboard3.component.ts